<template>
  <vs-row class="mb-5">
    <vs-col
      vs-order="1"
      vs-type="flex"
      vs-justify="center"
      vs-align="center"
      vs-w="4"
      class="px-1"
    >
      <vs-button color="warning" class="w-full h-16">
        <h4><b>เขตต่อเนื่อง</b></h4>
      </vs-button>
    </vs-col>
    <vs-col
      vs-order="2"
      vs-type="flex"
      vs-justify="center"
      vs-align="center"
      vs-w="4"
      class="px-1"
    >
      <vs-button color="#6E6F70" class="w-full h-16">
        <h4><b>ฝั่งทะเลอ่าวไทย</b></h4>
      </vs-button>
    </vs-col>
    <vs-col
      vs-order="3"
      vs-type="flex"
      vs-justify="center"
      vs-align="center"
      vs-w="4"
      class="px-1"
    >
      <vs-button color="#6E6F70" class="w-full h-16">
        <h4><b>ฝั่งทะเลอันดามัน</b></h4>
      </vs-button>
    </vs-col>
  </vs-row>
</template>

<script>
export default {};
</script>

<style>
b{
  color: white;
}
</style>
